export default class Polyfill {
    static removeHtmlElementNode(element) {
            if (element.parentNode !== null)
                element.parentNode.removeChild(element);
    }
}


// WEBPACK FOOTER //
// ./frontend/js/Polyfill.js